<template>
    <div class="notification-card" :class="{ seen: notification.seen }">
        <ActivityCard :activity="notification.activity" :show-date="false" />
        <div class="metas">
            <span class="date">{{ $moment(notification.createdAt).fromNow() }}</span>
            <div
                class="mark-read"
                :class="{ seen: notification.seen }"
                v-tippy="{
                    followCursor: false,
                    placement: 'left',
                }"
                @click="notificationSeen"
                :content="'Mark as Read'"
            ></div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions } from "vuex";
import ActivityCard from "../Activity/ActivityCard.vue";
import { ACTIVITY_API } from "../../../api/activity";

export default Vue.extend({
    name: "NotificationCard",
    components: { ActivityCard },
    props: {
        notification: {},
    },
    methods: {
        ...mapActions({
            setNotificationCount: "app/setNotificationCount",
            subNotificationCount: "app/subNotificationCount",
            addNotificationCount: "app/addNotificationCount",
        }),
        notificationSeen() {
            const promiseFn = this.notification.seen
                ? ACTIVITY_API.NOTIFICATION.markAsUnSeen
                : ACTIVITY_API.NOTIFICATION.markAsSeen;
            promiseFn([this.notification._id]).then(() => {
                if (this.notification.seen) {
                    this.addNotificationCount(1);
                    this.$emit("markUnread", this.notification._id);
                } else {
                    this.subNotificationCount(1);
                    this.$emit("markRead", this.notification._id);
                }
            });
        },
    },
});
</script>

<style scoped lang="scss">
.notification-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Inter, sans-serif;

    &:not(.seen) {
        background-color: #FFFFFF;
    }

    .metas {
        width: max-content;
        display: flex;
        gap: 12px;
        align-items: center;
        justify-content: flex-end;

        .date {
            font-size: 12px;
            color: #6B7280;
            font-weight: 400;
            font-family: Inter, sans-serif;
        }

        .mark-read {
            &:not(.seen) {
                width: 18px;
                height: 18px;
                background: #7C5CDB;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.2s ease;

                &:hover {
                    background: #6B4BC7;
                    box-shadow: 0 0 0 4px rgba(124, 92, 219, 0.1);

                    &:after {
                        content: "✓";
                        color: white;
                        font-size: 11px;
                        font-weight: 600;
                        line-height: 1;
                    }
                }
            }

            &.seen {
                width: 18px;
                height: 18px;
                border: 2px solid #D1D5DB;
                background-color: #FFFFFF;
                border-radius: 50%;
                cursor: pointer;
                transition: all 0.2s ease;

                &:hover {
                    border-color: #7C5CDB;
                    box-shadow: 0 0 0 4px rgba(124, 92, 219, 0.1);
                    background-color: #F5F3FF;
                }
            }
        }
    }

    .activity-card {
        width: calc(100% - 100px);
        padding: 0 !important;
        background: none !important;
    }

    .date {
        position: relative;
        display: inline;
        white-space: nowrap;

        &:after {
            content: "";
            display: none;
        }
    }
}
</style>
